import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown, FlexGrid, Label } from '@gasbuddy/react-components';

import styles from './styles.css';

const COMPETITION_SELECTOR_OPTIONS = [
  {
    label: 'National Competition',
    value: 'national',
  },
  {
    label: 'Regional Competition',
    value: 'regional',
  },
];

export default function CompetitionSelector({ onChange, value }) {
  const [competition, setCompetition] = React.useState(value || COMPETITION_SELECTOR_OPTIONS[0].value);

  React.useEffect(() => {
    setCompetition(value);
  }, [value]);

  const handleOnCompetitionChange = (e) => {
    const newValue = e.currentTarget.value;
    setCompetition(newValue);
    onChange(newValue);
  };

  return (
    <FlexGrid.Column>
      <Label htmlFor="competitionSelector">
        <span className={styles.labelText}>Compare To</span>
        <Dropdown
          id="competitionSelector"
          animated
          bordered
          value={competition}
          options={COMPETITION_SELECTOR_OPTIONS}
          onChange={handleOnCompetitionChange}
        />
      </Label>
    </FlexGrid.Column>
  );
}

CompetitionSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

CompetitionSelector.defaultProps = {
  onChange: () => { },
  value: COMPETITION_SELECTOR_OPTIONS[0].value,
};
